import { fromCents, toCents } from './money.js';
/** Issued invoices are the ciclo attivo, received ones the ciclo passivo. */
export function cycleOf(direction) {
    return direction === 'emessa' ? 'attivo' : 'passivo';
}
/**
 * The 1 January the situation starts from: 2024 (decision of 09/10/2026)
 * when its ledger is loaded, otherwise the first year with the year before
 * loaded, otherwise the first year.
 */
export function openingYearOf(years) {
    const loaded = new Set(years);
    if (loaded.has(2024))
        return 2024;
    const sorted = [...loaded].sort((a, b) => a - b);
    return sorted.find((year) => loaded.has(year - 1)) ?? sorted[0] ?? null;
}
/**
 * The totals of the invoices of one side; self-billing stays out, as in the
 * invoice lists, and so do the pro forma replaced by their invoices (1.59).
 */
export function statementTotals(items) {
    const counted = items.filter((item) => !item.selfBilling && !item.replaced);
    const sum = (pick) => counted.reduce((total, item) => total + toCents(pick(item)), 0);
    const invoiced = sum((item) => item.netDue);
    const residual = sum((item) => item.residual);
    return {
        invoiced: fromCents(invoiced),
        settled: fromCents(invoiced - residual),
        residual: fromCents(residual),
        overdue: fromCents(sum((item) => item.overdue)),
        count: counted.length,
    };
}
//# sourceMappingURL=statements.js.map